export const VISIBILITY_FILTERS = {
  ALL: "all",
  COMPLETED: "completed",
  INCOMPLETE: "incomplete"
};

const leftBar = window.innerWidth > 480 ? 72 : 52;
export const SIZES = {
  leftBar,
  leftBarOpened: leftBar + (window.innerWidth > 480 ? 355 : 275),
  topBar: 64
};
